module.exports = __webpack_public_path__ + "media/images/android-chrome-512x512-382caa2f26e7d69926d81137356928af.png";